/**
 * Authentication module event constants.
 * Use these constants instead of string literals to ensure type safety
 * and enable IDE features like "Find All References" and refactoring.
 */
export const AuthEvents = {
  /**
   * Emitted when a user successfully signs in.
   * Payload: AuthUser
   */
  SIGNIN: 'auth.signin',

  /**
   * Emitted when a user signs out.
   * Payload: none
   */
  SIGNOUT: 'auth.signout',

  /**
   * Emitted when user data has been updated (e.g., permissions, seat level, personal line).
   * Payload: AuthUser
   */
  USER_UPDATED: 'auth.user.updated',
} as const;

/**
 * Type representing valid authentication event names.
 */
export type AuthEventName = (typeof AuthEvents)[keyof typeof AuthEvents];
